import {
    PUBLISH_LINK,
    PUBLISH_LINK_FAILURE,
    PUBLISH_LINK_SUCCESS,
    SET_LINK_TRANSACTIONS,
    SET_PAYMENT_LINK,
    SET_PAYMENT_LINK_AVAILABLE,
    SET_PLAN_LINK,
    SET_SINGLE_PAYMENT_LINK
} from './actionTypes';

const initialState = {
    paymentLink: null,
    paymentLinkAvail: '',
    singlePaymentLink: null,
    loadingPaymentLink: true,
    publishSuccess: '',
    error: '',
    plans: null,
    transactions: null
};

const payments = (state = initialState, action) => {
    switch (action.type) {
        case SET_SINGLE_PAYMENT_LINK:
            state = { ...state, singlePaymentLink: action.payload };
            break;
        case SET_PAYMENT_LINK_AVAILABLE:
            state = { ...state, paymentLinkAvail: action.payload };
            break;
        case SET_PAYMENT_LINK:
            state = { ...state, paymentLink: action.payload, loadingPaymentLink: false };
            break;
        case PUBLISH_LINK:
            state = { ...state, loadingPaymentLink: true };
            break;
        case PUBLISH_LINK_SUCCESS:
            state = { ...state, loadingPaymentLink: false, publishSuccess: action.payload };
            break;
        case PUBLISH_LINK_FAILURE:
            state = { ...state, loadingPaymentLink: false, error: action.payload };
            break;
        case SET_PLAN_LINK:
            state = { ...state, plans: action.payload };
            break;
        case SET_LINK_TRANSACTIONS:
            state = { ...state, transactions: action.payload };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
};

export default payments;
